import { graphql } from "gql";

const ADMIN_EDIT_USER_ATTRIBUTE_MUTATION = graphql(`
  mutation AdminEditUserAttribute(
    $id: ID!
    $input: AdminEditUserAttributeInput!
  ) {
    adminEditUserAttribute(id: $id, input: $input) {
      ...UserAttribute
    }
  }
`);

export default ADMIN_EDIT_USER_ATTRIBUTE_MUTATION;
